import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "@/App";
import { Button } from "@/components/ui/button";

const Header = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <header className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20 lg:h-24">
          <div className="flex items-center space-x-2 sm:space-x-4 cursor-pointer" onClick={() => navigate("/")}>
            <img
              src="/images/logo.png"
              alt="EviDent Research Consultancy"
              className="h-10 sm:h-14 lg:h-20 w-auto"
            />
            <h1 className="text-[10px] sm:text-xl lg:text-3xl font-bold text-gray-900 leading-tight">
              EviDent
            </h1>
          </div>
          <div className="flex items-center space-x-0.5 sm:space-x-2">
            <Button
              variant="ghost"
              onClick={() => navigate("/about")}
              className="text-xs sm:text-sm px-2 sm:px-3"
            >
              About Us
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate("/publications")}
              className="text-xs sm:text-sm px-2 sm:px-3"
            >
              Publications
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate("/testimonials")}
              className="text-xs sm:text-sm px-2 sm:px-3"
            >
              Testimonials
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate("/submit/general-enquiry")}
              className="text-xs sm:text-sm px-2 sm:px-3"
            >
              Contact us
            </Button>
            {user ? (
              <Button
                data-testid="goto-dashboard-btn"
                onClick={() => navigate(user.role === 'admin' ? '/admin' : '/dashboard')}
                className="bg-blue-600 hover:bg-blue-700 text-xs sm:text-sm px-2 sm:px-4"
              >
                Dashboard
              </Button>
            ) : (
              <Button
                data-testid="login-btn"
                onClick={() => navigate("/login")}
                className="bg-blue-600 hover:bg-blue-700 text-xs sm:text-sm px-2 sm:px-4"
              >
                Sign In
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
